<template>
    <div v-if="review.member" id="review-detail" class="review-club-detail mt-5">
        <UserBox :review="review" />
        <MainBox :review="review" :all-review-images="allReviewImages" />
        <Modal :modal-name="`ask-question-login-${review.id}-detail`" role="dialog" aria-hidden="true" :title="$t('rating.title')">
            <!-- FIXME redirect -->
            <div class="modal-body">
                <i18n path="rating.login.mustLogin" tag="label" for="rating.login.signIn">
                    <a :href="$t('discussions.loginUrl')" v-html="$t('rating.login.signIn')" />
                </i18n>
            </div>
        </Modal>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import Review from '~/models/ReviewClub/Review'
import QuestionBlockImage from '~/models/ReviewClub/QuestionBlockImage'
import UserBox from '~/components/objects/ReviewClub/Detail/UserBox.vue'
import MainBox from '~/components/objects/ReviewClub/Detail/MainBox.vue'
import Modal from '~/components/Modal.vue'

export default {
    components: {
        Modal,
        MainBox,
        UserBox,
    },

    props: {
        review: {
            type: Object as PropType<Review>,
            required: true,
        },

        allReviewImages: {
            type: Array as PropType<QuestionBlockImage[]>,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.review-club-detail {
    display: flex;
    flex-wrap: wrap;
    font-size: 16px;
}
</style>
